import React, {FC} from 'react';
import styled, {css} from 'styled-components';

import {Handler} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {ChromelessButton} from '../../../../../../libs/shared/ui/src/components/buttons/chromelessButton';
import {boxShadow} from '../../../../../../libs/shared/ui/src/theme/themeStyleHelpers';

/*
 * Props.
 */

export interface FrameCardProps {
  onClick?: Handler;
  isEnabled?: boolean;
}

/*
 * Style.
 */

interface CardStyleProps {
  $isEnabled: boolean;
}
const StyledCardDiv = styled.div<CardStyleProps>`
  display: grid;
  grid-template-areas:
    '. avatar name     pin'
    '. avatar category pin';
  grid-template-columns: 0 auto 1fr auto;
  grid-template-rows: auto auto;
  grid-column-gap: 16px;
  grid-row-gap: 6px;
  height: 62px;

  background-color: ${(p) => p.theme.greys.white};
  border-radius: 16px;

  ${(p) => maybeAddEnabledStyle(p.$isEnabled)};
`;

function maybeAddEnabledStyle(isEnabled: boolean) {
  // Disabled style.
  if (!isEnabled) {
    return css`
      background-color: ${(p) => p.theme.greys.shade20};

      &:hover {
        background-color: ${(p) => p.theme.greys.shade30};
      }
    `;
  }

  // Enabled style.
  return css`
    background-color: ${(p) => p.theme.greys.white};
    ${(p) => boxShadow(p.theme, `0px 2px 10px ${p.theme.alphas.black40}`)};

    &:hover {
      background-color: ${(p) => p.theme.greys.shade10};
    }
  `;
}

/*
 * Component.
 */

export const FrameCard: FC<FrameCardProps> = (props) => (
  <ChromelessButton onClick={props.onClick}>
    <StyledCardDiv $isEnabled={Boolean(props.isEnabled)}>{props.children}</StyledCardDiv>
  </ChromelessButton>
);
